import { render, staticRenderFns } from "./tabGames.vue?vue&type=template&id=02c457d8"
import script from "./tabGames.vue?vue&type=script&lang=js"
export * from "./tabGames.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports